import { render, staticRenderFns } from "./edsCopyright.vue?vue&type=template&id=e630f274"
import script from "./edsCopyright.vue?vue&type=script&lang=js"
export * from "./edsCopyright.vue?vue&type=script&lang=js"
import style0 from "./edsCopyright.vue?vue&type=style&index=0&id=e630f274&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports